module.exports = __webpack_public_path__ + "static/media/overpass-mono-semibold.3eade9d0.ttf";